<template>
  <div>
    <v-row>
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <h4>Reason for Examination</h4>
      </v-col>

      <v-col :class="classPadding">
        <v-radio-group v-model="reasons" row>
          <v-radio label="Pre-placement" value="Pre-placement"></v-radio>
          <v-radio label="Periodic" value="Periodic"></v-radio>
          <v-radio label="Return-to-work" value="Return-to-work"></v-radio>
          <v-radio label="Transfer" value="Transfer"></v-radio>
          <v-radio label="Special" value="Special"></v-radio>
          <v-radio label="Separation" value="Separation"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <h4>Type of Examination</h4>
      </v-col>
      <custom :table="'tbl_DOLEExamType'"></custom>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <h4>Consultation / Treatment for the following:</h4>
      </v-col>
      <!-- Skin -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Skin:</p>
      </v-col>
      <custom :table="'tbl_DOLESkin'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Head -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Head:</p>
      </v-col>
      <custom :table="'tbl_DOLEHead'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Eyes -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Eyes:</p>
      </v-col>
      <custom :table="'tbl_DOLEEyes'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Mouth& ENT -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Mouth& ENT:</p>
      </v-col>
      <custom :table="'tbl_DOLEMouth'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Respiratory -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Respiratory:</p>
      </v-col>
      <custom :table="'tbl_DOLEResp'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Heart & Blood Vessels -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Heart & Blood Vessels:</p>
      </v-col>
      <custom :table="'tbl_DOLEHeart'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Gastrointestinal -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Gastrointestinal:</p>
      </v-col>
      <custom :table="'tbl_DOLEGastro'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Genito Urinary -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Genito Urinary:</p>
      </v-col>
      <custom :table="'tbl_DOLEUrinary'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Reproductive  -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Reproductive:</p>
      </v-col>
      <custom :table="'tbl_DOLEReprod'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Neuromuscular/Skeleal/Joints  -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Neuromuscular/Skeleal/Joints:</p>
      </v-col>
      <custom :table="'tbl_DOLESkeletal'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Lymphatic and Circulatory  -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Lymphatic and Circulatory:</p>
      </v-col>
      <custom :table="'tbl_DOLECircul'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
      <!-- Infectious Diseases  -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Infectious Diseases:</p>
      </v-col>
      <custom :table="'tbl_DOLEInfectD'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <h4>Diseases Due to Physical Environment:</h4>
      </v-col>

      <!-- Diseases Due to Noise and Vibration -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        &nbsp;
        <p>Diseases Due to Noise and Vibration:</p>
      </v-col>
      <custom :table="'tbl_DoleDieasNV'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>

      <!-- Diseases Due to Noise and Vibration -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Diseases Due to Temperature and Humidity Abnormalities:</p>
      </v-col>
      <v-container>
        <v-row class="pa-2">
          <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
            <p>Hot Temperature:</p>
          </v-col>
          <custom :table="'tbl_DOLEDieasTHHot'"></custom>
          <v-col cols="12" xs="12" sm="12" md="12" class="pl-3 pr-3">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="pa-2">
          <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
            <p>Cold Temperature:</p>
          </v-col>
          <custom :table="'tbl_DOLEDieasTHCold'"></custom>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-container>

      <!-- Diseases due to Pressure Abnormalities -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        &nbsp;
        <p>Diseases due to Pressure Abnormalities:</p>
      </v-col>
      <custom :table="'tbl_DOLEDieasPA'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>

      <!-- Diseases due to Radiation -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        &nbsp;
        <p>Diseases due to Radiation:</p>
      </v-col>
      <custom :table="'tbl_DOLEDieasRad'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <h4>Report of Occupational Accidents/injuries:</h4>
      </v-col>

      <!-- Nature  -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Nature :</p>
      </v-col>
      <custom :table="'tbl_DOLEInjury'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>

      <!-- Immunization Program   -->
      <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
        <p>Immunization Program :</p>
      </v-col>
      <custom :table="'tbl_DOLEImmune'"></custom>
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <!-- DOLE End -->
  </div>
</template>
<script>
// import ExamType from "./dole/ExamType";
import Custom from "./dole/Custom";
import EventBus from "../../../../events/eventBus";

export default {
  data: () => ({
    classPadding: "my-0 py-0",
    reasons: "Pre-placement",
  }),
  components: {
    // ExamType,
    Custom,
  },
  methods: {
    emitReasons() {
      EventBus.$emit("REASONS", this.reasons);
    },
  },
  created() {
    this.emitReasons();
  },
  watch: {
    reasons() {
      this.emitReasons();
    },
  },
};
</script>
